import { observer } from 'mobx-react';
import { CheckboxRequirementType } from '.';
import CheckBox from './CheckBox';

interface Props {
  tableColCount: number;
  checkBoxRequirement: CheckboxRequirementType;
}

function TableHeader({ tableColCount, checkBoxRequirement }: Props) {
  return (
    <tr>
      <CheckBox checkboxRequirement={checkBoxRequirement} />
      {[...Array(tableColCount)].map((_, index) => (
        <th key={index} scope="col" className="p-4">
          <div className="w-full h-4 bg-gray-300 rounded"></div>
        </th>
      ))}
      <th className="w-[40px] p-4">
        <div className="w-full h-4 rounded"></div>
      </th>
    </tr>
  );
}

export default observer(TableHeader);
